// extracted by mini-css-extract-plugin
export default {"stackedContentPage":"StackedContentPage_stackedContentPage__1Yv0z"};